
export default {
  // 食谱分类列表
  recipeCategoryListState: [],

  // 标签列表
  tagListState: [],

  // 型号列表
  productListState: [],

  // 工作模式列表
  workModeListState: [],
}
